import CheckCircle from '@mui/icons-material/CheckCircle'
import { Grid, Typography, Button, Box } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useCreateCompanyContext } from '../CreateCompanyContext'

function replaceSubdomain(url: string, toSubdomain: string) {
    const replace = '://' + toSubdomain + '.'
    // Prepend http://
    if (!/^\w*:\/\//.test(url)) {
        url = 'http://' + url
    }

    // Check if we got a subdomain in url
    if ((url.match(/\.\w*\b/g) || '').length > 1) {
        return url.replace(/(:\/\/\w+\.)/, replace)
    }

    return url.replace(/:\/\/(\w*\.)/, `${replace}$1`)
}

const REDIRECT_TIME = 6

function CreateResult() {
    const { restaurantLocation } = useCreateCompanyContext()
    const [redirectTime, setRedirectTime] = useState<number>(REDIRECT_TIME)

    const { t } = useTranslation()

    const onClick = useCallback(() => {
        const url = window.location.origin
        const newUrl = replaceSubdomain(url, restaurantLocation.subDomain)
        window.location.replace(newUrl)
    }, [restaurantLocation.subDomain])

    useEffect(() => {
        let interval = setInterval(() => {
            setRedirectTime((second) => second - 1)
        }, 1000)
        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        redirectTime === 0 && onClick()
    }, [redirectTime, onClick])
    return (
        <Box
            sx={{
                backgroundColor: '#ffffff',
                borderRadius: 8,
                pt: 4,
                minWidth: {
                    xs: 340,
                    sm: 340,
                    md: 400,
                },
                display: 'flex',
                width: '100%',
            }}
        >
            <Grid container direction="column">
                <Grid item>
                    <CheckCircle color="primary" style={{ fontSize: 70 }} />
                </Grid>
                <Grid item>
                    <Typography variant="h5" align="center">
                        Success!
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography align="center">
                        {t('register.label.success')}
                    </Typography>
                </Grid>
                <Grid item mb={4}>
                    <Typography align="center">
                        Redirect in ({redirectTime} second)
                    </Typography>
                </Grid>

                <Button
                    fullWidth
                    onClick={onClick}
                    disableElevation
                    color="primary"
                >
                    <Typography variant="h6">CONTINUE</Typography>
                </Button>
            </Grid>
        </Box>
    )
}

export default CreateResult
